<template>
  <b-card>
    <funcao-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :info="info"
      :filtros="filtros"
    />
  </b-card>
</template>

<style lang="scss">
</style>

<script>
import api from '@/app-modulo/comuns/funcao/shared/services/api'

export default {
  name: 'FuncaoVisualizacao',
  components: {
    FuncaoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [{ label: 'Nome', field: 'nome', editable: true }],
      filtros: [{ colunas: ['Nome'], valor: null }],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getFuncoes(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-funcao' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-funcao', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteFuncao(item.id)
            .then(() => {
              // tenporario
              if (i === itensInner.length - 1) {
                resolve()
              }
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
  },
}
</script>
